import * as Sentry from "@sentry/nuxt";

const config = useRuntimeConfig()

Sentry.init({
  // If set up, you can use your runtime config here
  // dsn: useRuntimeConfig().public.sentry.dsn,
  dsn: "https://e15bb21e08234965b6155f43d2eff7e5@o104085.ingest.us.sentry.io/4505390966767616",
  enabled: config.public.sentryEnabled,
  environment: config.public.sentryEnv,

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0,

  tracePropagationTargets: [
    "www.ugfunds.com",
    "v3.ugfunds.com",
    "test.ugfunds.com",
  ],

  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.1,
  
  // If the entire session is not sampled, use the below sample rate to sample
  // sessions when an error occurs.
  replaysOnErrorSampleRate: 1.0,
  
  // If you don't want to use Session Replay, just remove the line below:
  integrations: [
    /**
     * pinia only works for chatbot
     */
    // Sentry.piniaIntegration(usePinia()),
    Sentry.vueIntegration({
      tracingOptions: {
        trackComponents: true,
      },
    }),
    Sentry.replayIntegration()
  ],
  
  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,
  
});
